module.exports = __webpack_public_path__ + "static/logo-ai2-fullColor-withText-micro-ef68549b28be67779b583026a7badd47.svg";